<template>
  <div class="sn-page sn-assembly sn-f-c-c modal-page" v-if="!$sn.validate.empty(option)">
    <div class="modal-blank">
      <div class="sn-f-c-c modal-title" v-if="option.title">{{ option.title }}</div>
      <div class="modal-caption" v-if="option.caption">
        <div v-html="option.caption"></div>
      </div>
      <div class="sn-f-b-c modal-interaction">
        <template v-if="!option.slot && interaction.length > 0">
          <div class="sn-f-1 sn-f-c-c sn-pointer interaction" :class="{'sn-silence': item.duration > 0 && item.disabled}"
            :style="{
              'color': item.font
            }"
            :key="i" v-for="(item, i) in interaction"
            @click="item.duration > 0 && item.disabled ? null : sendBack(item.type)">
            {{ item.duration > 0 ? item.caption + '（' + item.duration + 's）' : item.caption }}
          </div>
        </template>
        <template v-else-if="option.slot">
          <slot name="interaction"></slot>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'modal',
  props: {
    separate: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      option: {},
      interaction: [],
      intervalConfirm: null,
      intervalCancel: null
    };
  },
  created: function() {
    if (this.$sn.vuex.get('vuex_modal.type')) {
      this.option = this.$sn.vuex.get('vuex_modal');
    }
    else {
      if (!this.$sn.validate.empty(this.separate) && this.separate.slot) {
        this.option = this.$sn.format.deepClone(this.separate);
      }
    }
    if (!this.$sn.validate.empty(this.option)) {
      this.initialInteraction();
    }
  },
  methods: {
    initialInteraction() {
      this.interaction = [];
      if (this.intervalConfirm) {
        clearInterval(this.intervalConfirm);
        this.intervalConfirm = null;
      }
      if (this.intervalCancel) {
        clearInterval(this.intervalCancel);
        this.intervalCancel = null;
      }
      if (!this.option.slot) this.formatInteraction();
    },
    formatInteraction() {
      // 初始化按钮信息
      ['Confirm', 'Cancel'].forEach(el => {
        if (this.option['is' + el]) {
          const standard = {
            identify: el,
            type: false,
            caption: this.option['caption' + el],
            font: this.option['color' + el],
            duration: this.option['duration' + el],
            disabled: this.option['disabled' + el],
            auto: this.option['auto' + el],
            sort: 1
          };
          if (el === 'Confirm') {
            standard.type = true;
            standard.sort = this.option.transfer ? 0 : 2;
          }
          this.interaction.push(standard);
        }
      });
      this.interaction = this.$sn.format.digitalSort(this.interaction);
      // 如有倒计时，则开始进行倒计时
      this.interaction.forEach(el => {
        if (el.duration > 0) {
          this['interval' + el.identify] = setInterval(() => {
            if (el.duration > 0) {
              el.duration--;
            }
            else {
              clearInterval(this['interval' + el.identify]);
              this['interval' + el.identify] = null;
              if (el.auto) this.sendBack(el.type);
            }
          }, 1000);
        }
      });
    },
    sendBack(type) {
      this.$sn.vuex.set('vuex_modal', {});
      if (this.$sn.validate.func(this.option.success)) {
        const result = {};
        if (type) this.$set(result, 'confirm', true);
        else this.$set(result, 'cancel', true);
        this.option.success(result);
      }
      if (this.intervalConfirm) {
        clearInterval(this.intervalConfirm);
        this.intervalConfirm = null;
      }
      if (this.intervalCancel) {
        clearInterval(this.intervalCancel);
        this.intervalCancel = null;
      }
    }
  },
  beforeDestroy() {
    if (this.intervalConfirm) {
      clearInterval(this.intervalConfirm);
      this.intervalConfirm = null;
    }
    if (this.intervalCancel) {
      clearInterval(this.intervalCancel);
      this.intervalCancel = null;
    }
  }
};
</script>
<style lang="scss">
  .modal-page {
    .modal-blank {
      overflow: hidden;
      width: 327px;
      background-color: $white;
      border-radius: 16px;
      padding-top: 24px;

      .modal-title {
        @include fs(20);

        overflow: hidden;
        width: 100%;
        font-weight: bold;
        color: $text1;
        padding: 0 36px 15px;
      }

      .modal-caption {
        @include fs(16);

        overflow-x: hidden;
        overflow-y: scroll;
        -webkit-overflow-scrolling: touch;
        width: 100%;
        max-height: 287px;
        color: $text3;
        text-align: justify;
        padding: 0 36px;
        margin-bottom: 24px;
      }

      .modal-interaction {
        width: 100%;
        height: 60px;
        border-top: 1px solid $border1;

        .interaction {
          @include fs(18);

          height: 60px;
          font-weight: bold;
          border-left: 1px solid $border1;

          &:first-child {
            border-left: none;
          }
        }
      }
    }
  }
</style>
